import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { ToastrService } from "ngx-toastr";
import { first } from "rxjs/operators";
import { PaymentTestingService } from "src/app/services/payment-testing.service";
import { WebConstants } from "src/app/util/web.constants";

@Component({
  selector: "app-payment-testing-file-uploader",
  templateUrl: "./payment-testing-file-uploader.component.html",
  styleUrls: ["./payment-testing-file-uploader.component.scss"],
})
export class PaymentTestingFileUploaderComponent implements OnInit {
  public allowedFileTypes: any = ["text/csv"];
  public fileData: File = null;
  public fileName: string = "No file Chosen";
  public fileSize: any = "";
  public form: any;

  public passCount: any = 0;
  public errorCount: any = 0;

  public progress: number = -1;

  constructor(
    public dialogRef: MatDialogRef<PaymentTestingFileUploaderComponent>,
    public toastrService: ToastrService,
    public paymentTestingService: PaymentTestingService
  ) {}

  ngOnInit(): void {}

  public readFile() {
    if (this.fileData) {
      let reader: FileReader = new FileReader();
      reader.readAsText(this.fileData);

      reader.onload = (e) => {
        let payloadArr = [];
        let csv: string = reader.result as string;
        let rowArr = csv.split("\r\n");
        if (rowArr) {
          for (let i = 0; i < rowArr.length; i++) {
            if (rowArr[i] && rowArr[i] != "") {
              let colArr = rowArr[i].split(",");
              if (
                i === 0 &&
                !(colArr && colArr.length >= 1 && colArr[0] === "LicensePlate")
              ) {
                this.toastrService.error(
                  "Please follow Sample CSV ",
                  "Invalid Excel Header"
                );
                break;
              }
              if (
                colArr &&
                colArr.length >= 1 &&
                colArr[0] !== "LicensePlate"
              ) {
                let numberPlate = colArr[0];
                let serviceName = colArr[1];
                let startTime = +new Date(colArr[2]);
                let endTime = +new Date(colArr[3]);
                let zone = colArr[4];

                if (numberPlate.trim() != "") {
                  if (numberPlate.length > 3 && numberPlate.length < 10) {
                    payloadArr.push({
                      numberPlate: numberPlate.trim().toUpperCase(),
                      serviceName: serviceName.trim(),
                      startTime: startTime,
                      endTime: endTime,
                      zone: zone.trim(),
                    });
                    this.passCount += 1;
                  } else {
                    this.toastrService.error(
                      '"' + numberPlate + '" is an Invalid Number Plate'
                    );
                    this.errorCount += 1;
                  }
                } else {
                  this.errorCount += 1;
                }
              }
            }
          }
        }
        if (payloadArr && payloadArr.length > 0) {
          this.bulkUpload(payloadArr);
        }
      };
    }
  }

  fileProgress(fileInput: any) {
    let fileData = <File>fileInput.target.files[0];
    if (this.allowedFileTypes.includes(fileData.type)) {
      this.fileData = fileData;
      this.fileName = fileData.name;
      this.fileSize = fileData.size;
      this.toastrService.info(
        "File : " + this.fileName + " ; Size: " + this.fileSize,
        "File Selected"
      );
    } else {
      this.fileData = null;
      this.fileName = "No file chosen";
      this.fileSize = "";
      this.toastrService.warning(
        "Please select correct file",
        "Wrong File Type Error"
      );
    }
  }

  bulkUpload(payloadArr) {
    this.paymentTestingService
      .addMultipleLPNPaymentList(payloadArr)
      .pipe(first())
      .subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(
            response.value,
            "Licence Plate Payment Added Successfully!"
          );
          if (this.errorCount > 0) {
            this.toastrService.info(
              this.passCount +
                " Licence Plate Payment Added, </br>" +
                this.errorCount +
                " Failed",
              "Result",
              { enableHtml: true }
            );
          } else {
            this.toastrService.info(
              this.passCount + " Licence Plate Payment Added",
              "Result",
              { enableHtml: true }
            );
          }
          this.closeDialog(true);
        } else {
          this.toastrService.error(
            response.value,
            "Failed To Add Licence Plate Payment!"
          );
          this.closeDialog(false);
        }
      });
  }

  chooseFile() {
    let myInput = document.getElementById("myInput");
    myInput.click();
  }

  closeDialog(reload: boolean): void {
    this.dialogRef.close(reload);
  }
}
